import React from "react"
import { useMediaQuery } from "react-responsive"
import { Book } from "src/openapi"
import { Box, Grid, Image, Typography } from "src/UILibrary"

interface Props {
  item: Book
  handleSelected?: any
}

export const BooksTableItem = ({ item, handleSelected }: Props) => {
  const isPC = useMediaQuery({ query: "(min-width: 1400px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const extractDate = (date?: string) => {
    let ret
    if (!date) return ""
    ret = date.replaceAll("-", "/")
    ret = ret.replaceAll("T", " ")
    return ret.substring(0, 16)
  }

  return (
    <Box
      sx={{
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
      onClick={() => handleSelected(item)}
    >
      {isTablet ? (
        <Grid
          container
          sx={{
            mt: "0px",
            height: "32px",
            borderBottom: "1px dotted #D4D3D7",
            minHeight: "80px",
          }}
        >
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 2}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {extractDate(item.updatedAt)}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 2}
            sm={12}
            xs={12}
            fontSize={13}
            sx={{ my: "auto", px: "20px" }}
          >
            <Image
              src={item.imageUrl!}
              sx={{
                width: "55px",
                height: "70px",
                bgcolor: "divider",
                flex: 1,
              }}
              imageStyle={{ width: "100%", height: "100%" }}
            />
          </Grid>
          <Grid
            item
            color="text.primary"
            md={isPC ? 4 : isTablet ? 4 : 4}
            sm={12}
            xs={12}
            fontSize={12}
            sx={{ my: "auto", fontSize: "13px", px: "20px" }}
          >
            <Typography.SubHeadNormal
              className="notosans weight500 restrict_line"
              sx={{ fontSize: "13px" }}
            >
              {item.title}
            </Typography.SubHeadNormal>
          </Grid>
          <Grid
            item
            className="notosans weight500 restrict_line"
            color="text.primary"
            md={isPC ? 4 : isTablet ? 4 : 4}
            sm={12}
            xs={12}
            fontSize={12}
            sx={{ my: "auto", fontSize: "13px", px: "20px" }}
          >
            <Typography.SubHeadNormal
              className="notosans restrict_line"
              sx={{ fontSize: "12px", maxWidth: "455px" }}
            >
              {item.bookUrl}
            </Typography.SubHeadNormal>
          </Grid>
        </Grid>
      ) : (
        <Box display="display" sx={{ borderBottom: "1px dotted #D4D3D7" }}>
          <Box
            className="notosans weight500"
            color="text.primary"
            fontSize={14}
            width={150}
            sx={{ mt: "10px", ml: "10px", color: "#222222" }}
          >
            {extractDate(item.updatedAt)}
          </Box>
          <Box display="flex">
            <Box sx={{ m: "8px 0px 8px 10px", my: "auto" }}>
              <Image
                src={item.imageUrl!}
                sx={{
                  width: "55px",
                  height: "70px",
                  bgcolor: "divider",
                  flex: 1,
                }}
                imageStyle={{ width: "100%", height: "100%" }}
              />
            </Box>
            <Box display="block" width="calc(100% - 90px)">
              <Box
                className="notosans weight500"
                sx={{ p: "10px 10px 0px", mb: "0px", color: "#222222" }}
              >
                <Typography.SubHeadNormal
                  className="limit_line_sp"
                  sx={{ fontSize: "13px", mr: "20px", width: "100%!important" }}
                >
                  {item.title}
                </Typography.SubHeadNormal>
              </Box>
              <Box
                className="notosans weight500"
                sx={{
                  fontSize: "12px",
                  p: "0px 10px 0px",
                  mb: "10px",
                  color: "#222222",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography.SubHeadNormal
                  className="notosans restrict_line"
                  sx={{ fontSize: "12px", mr: "20px" }}
                >
                  {item.bookUrl}
                </Typography.SubHeadNormal>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
